'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAddonsUpdate = require('react-addons-update');

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _reactBootstrap = require('react-bootstrap');

var _reactRedux = require('react-redux');

var _users = require('redux/modules/users');

var userActions = _interopRequireWildcard(_users);

var _reactRouter = require('react-router');

var _components = require('components');

var _can = require('helpers/can');

var _can2 = _interopRequireDefault(_can);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserForm = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    authUser: state.auth.user,
    user: state.users.user,
    image: state.users.image,
    loaded: state.users.loaded,
    loading: state.users.loading,
    saving: state.users.saving,
    saveError: state.users.saveError
  };
}, (0, _extends3.default)({}, userActions), null, { withRef: true }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(UserForm, _Component);

  function UserForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, UserForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = UserForm.__proto__ || (0, _getPrototypeOf2.default)(UserForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      autofocus: false,
      showCloseModalPopover: false,
      showInheritedRights: false,
      user: _this.props.user,
      userHasChanged: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(UserForm, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.props.userId) {
        this.setState({
          autofocus: true
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          userId = _props.userId,
          getUser = _props.getUser,
          newUser = _props.newUser;


      if (userId) {
        getUser(userId);
      } else {
        newUser();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.user !== this.props.user) {
        this.setState({ user: nextProps.user });
      }

      if (nextProps.image !== this.props.image) {
        this.setState({
          user: (0, _reactAddonsUpdate2.default)(this.state.user, { $merge: { avatar: nextProps.image } })
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.removeErrors();
    }
  }, {
    key: 'validateName',
    value: function validateName(ev) {
      if (ev.keyCode === 13 || ev.keyCode === 9) {
        document.getElementById('user-name-box').blur();
      }
    }
  }, {
    key: 'toggleChangeInherited',
    value: function toggleChangeInherited() {
      this.setState({
        showInheritedRights: !this.state.showInheritedRights
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(ev, key) {
      var user = this.state.user;


      user = (0, _reactAddonsUpdate2.default)(user, {
        $merge: (0, _defineProperty3.default)({}, key, ev.target.value)
      });

      this.updateUserState(user);
    }
  }, {
    key: 'handleChangeEmail',
    value: function handleChangeEmail(ev) {
      this.handleChange(ev, 'email');
    }
  }, {
    key: 'handleChangeName',
    value: function handleChangeName(ev) {
      this.handleChange(ev, 'name');
    }
  }, {
    key: 'handleChangePassword',
    value: function handleChangePassword(ev) {
      this.handleChange(ev, 'password');
    }
  }, {
    key: 'handleDeleteImage',
    value: function handleDeleteImage(imageId) {
      var _props2 = this.props,
          deleteImage = _props2.deleteImage,
          loading = _props2.loading;
      var user = this.state.user;


      if (!loading) {
        if (imageId) {
          deleteImage(imageId);
        }

        user = (0, _reactAddonsUpdate2.default)(user, {
          $merge: {
            avatar: null
          }
        });

        this.updateUserState(user);
      }
    }
  }, {
    key: 'handleChangeImage',
    value: function handleChangeImage(image) {
      var _this2 = this;

      var _props3 = this.props,
          saveImage = _props3.saveImage,
          loading = _props3.loading;
      var user = this.state.user;


      if (!loading) {
        saveImage(image).then(function (res) {
          if (res && res.type === userActions.SAVE_IMAGE_SUCCESS) {
            user = (0, _reactAddonsUpdate2.default)(user, {
              $merge: {
                avatar: res.result
              }
            });

            _this2.updateUserState(user);
          }
        });
      }
    }
  }, {
    key: 'updateUserState',
    value: function updateUserState(user, callback) {
      this.setState({
        user: user,
        userHasChanged: true
      }, function () {
        if (callback) {
          callback();
        }
      });
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this3 = this;

      var save = this.props.save;
      var user = this.state.user;


      var payload = (0, _extends3.default)({}, user, {
        new_password: user.password ? user.password : ''
      });

      save(payload).then(function (res) {
        if (res && res.type === userActions.SAVE_SUCCESS) {
          _this3.handleCloseModal();
        }
      }).catch(function (error) {
        throw error;
      });
    }
  }, {
    key: 'handleCloseModal',
    value: function handleCloseModal() {
      this.props.closeModal();
    }
  }, {
    key: 'showCloseModalPopover',
    value: function showCloseModalPopover() {
      this.setState({
        showCloseModalPopover: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          authUser = _props4.authUser,
          saving = _props4.saving,
          saveError = _props4.saveError,
          loaded = _props4.loaded,
          loading = _props4.loading,
          requireCloseModal = _props4.requireCloseModal,
          polyglot = _props4.polyglot;
      var _state = this.state,
          showInheritedRights = _state.showInheritedRights,
          user = _state.user;

      var hasErrors = saveError && saveError[user.id];
      var errorMessage = hasErrors ? polyglot.t('errors.' + saveError[user.id].status_code) : '';
      var errorFields = hasErrors ? saveError[user.id].errors : '';

      return _react2.default.createElement(
        _components.Loader,
        { loaded: loaded },
        _react2.default.createElement(
          'div',
          { className: 'modal-body' },
          _react2.default.createElement(
            'div',
            { className: 'user-form' },
            _react2.default.createElement(
              _reactBootstrap.OverlayTrigger,
              {
                trigger: 'click',
                placement: 'bottom',
                rootClose: true,
                overlay: _react2.default.createElement(
                  _reactBootstrap.Popover,
                  { id: 'closeModalPopover', className: 'closeform-box-popover' },
                  _react2.default.createElement(_components.CloseModalPopover, { close: this.handleCloseModal.bind(this), save: this.handleSave.bind(this), saving: saving, scope: 'users', polyglot: polyglot })
                )
              },
              _react2.default.createElement('button', {
                type: 'button',
                onClick: requireCloseModal,
                className: 'close-modal-button icon-cg-close'
              })
            ),
            _react2.default.createElement('input', {
              type: 'text',
              id: 'user-name-box',
              className: 'form-control input-h1' + (errorFields && errorFields.name ? ' has-error' : ''),
              onChange: this.handleChangeName.bind(this),
              onKeyUp: this.validateName.bind(this),
              defaultValue: user.name,
              autoFocus: this.state.autofocus,
              placeholder: polyglot.t('users.titleBox.help')
            }),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-sm-4' },
                _react2.default.createElement(_components.ImageBox, {
                  handleChangeImage: this.handleChangeImage.bind(this),
                  handleDeleteImage: this.handleDeleteImage.bind(this),
                  loading: loading,
                  image: user.avatar,
                  polyglot: polyglot
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-sm-8' },
                _react2.default.createElement(
                  'div',
                  { className: 'line-box' },
                  _react2.default.createElement(
                    'div',
                    { className: 'form-group' },
                    _react2.default.createElement('input', {
                      type: 'email',
                      id: 'user-email-box',
                      className: 'form-control' + (errorFields && errorFields.email ? ' has-error' : ''),
                      onChange: this.handleChangeEmail.bind(this),
                      defaultValue: user.email,
                      placeholder: polyglot.t('users.attributes.email')
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'form-group' },
                    _react2.default.createElement(_components.PasswordInput, {
                      id: 'user-password-box',
                      className: 'form-control password' + (errorFields && errorFields.password ? ' has-error' : ''),
                      onChange: this.handleChangePassword.bind(this),
                      defaultValue: '',
                      placeholder: polyglot.t('users.attributes.password'),
                      polyglot: polyglot
                    })
                  )
                ),
                user.id && _react2.default.createElement(
                  'div',
                  { className: 'line-box access-rights-box' },
                  _react2.default.createElement(
                    'label',
                    null,
                    polyglot.t('users.accessRights.title')
                  ),
                  _react2.default.createElement(
                    _reactBootstrap.Button,
                    { bsStyle: 'link', bsSize: 'small', className: 'toggle-button', onClick: this.toggleChangeInherited.bind(this) },
                    showInheritedRights ? polyglot.t('users.accessRights.hideInheritedRights') : polyglot.t('users.accessRights.showInheritedRights')
                  ),
                  user && user.calendars && user.calendars.length > 0 && _react2.default.createElement(
                    'h4',
                    { className: 'text-left' },
                    polyglot.t('users.accessRights.calendars')
                  ),
                  user && user.calendars && user.calendars.map(function (calendar) {
                    var authCalendar = authUser.calendars.find(function (cal) {
                      return cal.id === calendar.id;
                    });
                    var isAdmin = authCalendar && (0, _can2.default)('admin', [authCalendar]);
                    return showInheritedRights || !calendar.inherited ? _react2.default.createElement(
                      'div',
                      { className: 'calendar-role-row row', key: 'calendar-' + calendar.id },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-sm-5' },
                        isAdmin && !calendar.inherited ? _react2.default.createElement(
                          _reactRouter.Link,
                          { to: '/calendars/' + calendar.id + '/settings' },
                          _react2.default.createElement(
                            'strong',
                            null,
                            calendar.name
                          )
                        ) : _react2.default.createElement(
                          'strong',
                          null,
                          calendar.name
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-sm-2' },
                        polyglot.t('userRoleSelector.as'),
                        '\xA0'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-sm-5' },
                        _react2.default.createElement(
                          'strong',
                          null,
                          polyglot.t('roles.' + calendar.role)
                        )
                      )
                    ) : '';
                  }),
                  user && user.organizations && user.organizations.length > 0 && _react2.default.createElement(
                    'h4',
                    { className: 'text-left' },
                    polyglot.t('users.accessRights.organizations')
                  ),
                  user && user.organizations && user.organizations.map(function (organization) {
                    var authOrganization = authUser.organizations.find(function (org) {
                      return org.id === organization.id;
                    });
                    var isAdmin = authOrganization && (0, _can2.default)('admin', [authOrganization]);
                    return showInheritedRights || !organization.inherited ? _react2.default.createElement(
                      'div',
                      { className: 'organization-role-row row', key: 'organization-' + organization.id },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-sm-5' },
                        isAdmin && !organization.inherited ? _react2.default.createElement(
                          _reactRouter.Link,
                          { to: '/organizations/' + organization.id },
                          _react2.default.createElement(
                            'strong',
                            null,
                            organization.name
                          )
                        ) : _react2.default.createElement(
                          'strong',
                          null,
                          organization.name
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-sm-2' },
                        polyglot.t('userRoleSelector.as'),
                        '\xA0'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-sm-5' },
                        _react2.default.createElement(
                          'strong',
                          null,
                          polyglot.t('roles.' + organization.role)
                        )
                      )
                    ) : '';
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'modal-footer' },
          _react2.default.createElement(
            'div',
            { className: 'pull-right' },
            _react2.default.createElement(
              'span',
              { className: 'status-label label label-danger' },
              errorMessage
            ),
            _react2.default.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-primary',
                onClick: !saving ? this.handleSave.bind(this) : null,
                disabled: saving
              },
              saving ? _react2.default.createElement('i', { className: 'glyphicon glyphicon-refresh cg-spinner' }) : '',
              ' ',
              polyglot.t('form.save')
            )
          )
        )
      );
    }
  }]);
  return UserForm;
}(_react.Component), _class2.propTypes = {
  authUser: _propTypes2.default.object.isRequired,
  closeModal: _propTypes2.default.func,
  deleteImage: _propTypes2.default.func,
  getUser: _propTypes2.default.func,
  image: _propTypes2.default.object,
  loaded: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  newUser: _propTypes2.default.func,
  polyglot: _propTypes2.default.object.isRequired,
  removeErrors: _propTypes2.default.func,
  requireCloseModal: _propTypes2.default.func,
  save: _propTypes2.default.func.isRequired,
  saving: _propTypes2.default.bool,
  saveError: _propTypes2.default.object,
  saveImage: _propTypes2.default.func.isRequired,
  user: _propTypes2.default.object,
  userId: _propTypes2.default.number
}, _temp2)) || _class);
exports.default = UserForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/User/UserForm.js
// module id = 2248
// module chunks = 0